module.exports = __webpack_public_path__ + "assets/img/53@3x.45819346.png";